export const RESOURCE_PLANNING_CONFIG = {
    name            : 'Resource planning',
    icon            : 'i5-timeline',
    image           : 'resource-planning',
    url             : 'resource-planning',
    description     : 'Detailed team resources and work hours view for time-based planning.'
}
